import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import React from 'react';

import { Redirect } from 'react-router-dom';

function formatError(error) {
    if (typeof error === 'string') {
        return <span style={{ color: 'red' }}>{error}</span>;
    }
    return <pre style={{ color: 'red' }}>{JSON.stringify(error, null, 4)}</pre>;
}

function formatQuery(o) {
    return Object.keys(o)
        .map((i) => `${encodeURIComponent(i)}=${encodeURIComponent(o[i])}`)
        .join('&');
}

class Authenticate extends React.PureComponent {
    state = {
        error: null,
        redirecting: false,
    };

    componentDidMount() {
        this.checkLogin();
    }

    async checkLogin() {
        const tokenResponse = await fetch('/api/token/platform', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ code: this.props.code, state: this.props.state }),
        });
        const tokenResult = await tokenResponse.json();
        if (tokenResult.error) {
            this.setState({ error: tokenResult.error });
            return;
        }
        const token = tokenResult.token;

        const loginResponse = await fetch('/api/login/v2', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token: token }),
        });
        if (loginResponse.error) {
            this.setState({ error: loginResponse.error });
            return;
        }
        this.setState({ redirecting: true });
    }

    render() {
        if (this.state.redirecting) {
            let url = this.props.url ?? '/';
            window.location.href = url;
            return null;
        }
        return <div>{this.state.error ? <div>{formatError(this.state.error)}</div> : <div>Login...</div>}</div>;
    }
}

export class Login extends React.PureComponent {
    constructor(props) {
        super(props);
        this.urlParams = new URLSearchParams(window.location.search);
        this.state = {
            loading: true,
            state: '',
            authPlatformClientId: '',
            authServerUrl: '',
        };
    }

    async componentDidMount() {
        if (this.urlParams.get('code')) {
            return;
        }
        const response = await fetch('/api/request_login');
        const result = await response.json();
        this.setState({
            loading: false,
            state: result.state,
            authServerUrl: result.authServerUrl,
            authPlatformClientId: result.authPlatformClientId,
        });
    }

    getAuthServerUrl() {
        const params = {
            response_type: 'code',
            redirect_uri: `${window.location.origin}/login`,
            client_id: this.state.authPlatformClientId,
            scope: 'openid profile email permissions offline_access',
            prompt: 'consent',
            state: JSON.stringify({state: this.state.state, url: this.urlParams.get('url')}),
        };
        return `${this.state.authServerUrl}/auth?${formatQuery(params)}`;
    }

    loginWithAuthServer = () => {
        window.open(this.getAuthServerUrl(), '_self');
    };

    render() {
        const code = this.urlParams.get('code');
        if (code) {
            const {state, url} = JSON.parse(this.urlParams.get('state'));
            return <Authenticate code={code} state={state} url={url} />;
        }
        if (this.state.loading) {
            return <div>Loading...</div>;
        }
        return (
            <div>
                <Grid justify="center" alignItems="center" container style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }}>
                    <Grid item>
                        <h2 className="loginHeader">Sign in to DCEI Platform</h2>
                        <Button variant="contained" color="primary" onClick={this.loginWithAuthServer}>
                            Login
                        </Button>
                    </Grid>
                </Grid>
            </div>
        );
    }
}
